<template>
  <main-layout
    :title="categoryTitle"
  >
    <template v-slot:titleActions>
      <guide-help-button
        v-if="categoryConst === 'apartment' && !isLoading && hasAds"
        guide-name="apartments"
        button-text="Help guide"
      />
    </template>
    <template v-slot:body>
      <ads-table
        :category-const="categoryConst"
        @category-loaded="onCategoryLoaded"
        @ads-loaded="onAdsLoaded"
      />
    </template>
  </main-layout>
</template>

<script>
import MetaTitleMixin from '@/lib/MetaTitleMixin';
import AdsTable from '@/components/tables/AdsTable.vue';
import GuideHelpButton from '@/components/GuideHelpButton.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [MetaTitleMixin],
  components: {
    AdsTable,
    GuideHelpButton,
  },
  props: {
    categoryConst: {
      required: false,
      type: String,
    },
  },
  data() {
    return {
      category: null,
      hasAds: false,
    };
  },
  computed: {
    ...mapGetters(['loading']),
    isLoading() {
      return this.loading;
    },
    categoryTitle() {
      if (!this.category || !this.category.name) {
        return '';
      }
      return this.category.name[this.$i18n.locale];
    },
  },
  watch: {
    categoryTitle(value) {
      if (value) {
        this.$title = value;
      }
    },
  },
  methods: {
    onCategoryLoaded(category) {
      this.category = category;
    },
    onAdsLoaded(ads) {
      this.hasAds = Boolean(ads && ads.length);
    },
  },
};
</script>
